export default function DeliveryTruck(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.4375 3.71875H18.5729V18.5694H1.4375V3.71875Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.5703 9.43066H23.1398L26.5668 12.8577V18.5696H18.5703V9.43066Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.71875 21.4252C3.71875 22.1827 4.01964 22.9091 4.55522 23.4447C5.09081 23.9803 5.81722 24.2811 6.57465 24.2811C7.33209 24.2811 8.0585 23.9803 8.59408 23.4447C9.12967 22.9091 9.43056 22.1827 9.43056 21.4252C9.43056 20.6678 9.12967 19.9414 8.59408 19.4058C8.0585 18.8702 7.33209 18.5693 6.57465 18.5693C5.81722 18.5693 5.09081 18.8702 4.55522 19.4058C4.01964 19.9414 3.71875 20.6678 3.71875 21.4252Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.5703 21.4252C18.5703 22.1827 18.8712 22.9091 19.4068 23.4447C19.9424 23.9803 20.6688 24.2811 21.4262 24.2811C22.1836 24.2811 22.9101 23.9803 23.4456 23.4447C23.9812 22.9091 24.2821 22.1827 24.2821 21.4252C24.2821 20.6678 23.9812 19.9414 23.4456 19.4058C22.9101 18.8702 22.1836 18.5693 21.4262 18.5693C20.6688 18.5693 19.9424 18.8702 19.4068 19.4058C18.8712 19.9414 18.5703 20.6678 18.5703 21.4252Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
